import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "gfu-header__actions gfu-navbar-nav",
  "data-qa": "navbar-header-actions"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "gfu-navbar-item _screen--none _screen--flex-m",
  "data-qa": "header-actions:CurrencySelector"
}
const _hoisted_4 = {
  key: 3,
  class: "gfu-navbar-item"
}
const _hoisted_5 = ["href", "title", "aria-label"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_currency_selector = _resolveComponent("currency-selector")
  const _component_language_selector_button = _resolveComponent("language-selector-button")
  const _component_cart_box = _resolveComponent("cart-box")
  const _component_mobile_notification_center = _resolveComponent("mobile-notification-center")
  const _component_mobile_user_navigation = _resolveComponent("mobile-user-navigation")
  const _component_push_notification_manager = _resolveComponent("push-notification-manager")
  const _component_user_box = _resolveComponent("user-box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "gfu-navbar-btn gfu-navbar-btn--narrow gfu-search-button",
      "aria-label": _ctx.Resources.Layout.SearchFormSearchButtonLabel,
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onSearchToggle && $options.onSearchToggle(...args)))
    }, [
      _createVNode(_component_base_icon, {
        name: "search",
        size: "lg"
      })
    ], 8 /* PROPS */, _hoisted_2),
    ($options.isCurrencySelectorVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_currency_selector, { class: "gfu-navbar-btn gfu-navbar-btn--narrow" })
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isLanguageSelectorVisible)
      ? (_openBlock(), _createBlock(_component_language_selector_button, { key: 1 }))
      : _createCommentVNode("v-if", true),
    ($options.isCartBoxVisible)
      ? (_openBlock(), _createBlock(_component_cart_box, { key: 2 }))
      : _createCommentVNode("v-if", true),
    ($options.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "gfu-navbar-link--no-fx _cur-p _tdn",
            href: $options.backerCenterDashboardUrl,
            title: _ctx.Resources.BackerCenter.YourDashboardPageTitle,
            "aria-label": _ctx.Resources.BackerCenter.YourDashboardPageTitle,
            "data-qa": "header-actions:BackerCenter"
          }, [
            _createVNode(_component_base_icon, {
              name: "books-icon",
              size: "lg",
              "icon-namespace": "ga",
              class: "gfu-navbar-btn gfu-navbar-btn--narrow"
            })
          ], 8 /* PROPS */, _hoisted_5)
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isMobile)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createVNode(_component_mobile_notification_center),
          _createVNode(_component_mobile_user_navigation, { "data-qa": "mobile-user-navigation" })
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
          _createVNode(_component_push_notification_manager),
          _createVNode(_component_user_box)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}